'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { AuthQueryOptions } from '@/api';
import { InquiryCard } from '@/app/donation/_components/InquiryCard';
import type { InquiryType } from '@/app/donation/types';

import { DesktopTitle } from '../../../_components/DesktopTitle';

const InquiryHistoryPage = () => {
  const { data } = useSuspenseQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/home-inquiry/my'](),
    select: (data) => ({
      list: data.context?.contents ?? [],
      totalCount: data.context?.totalCount ?? 0,
    }),
  });

  const isEmpty = data.totalCount < 1;

  return (
    <section className="flex size-full flex-col gap-7 pb-32">
      <DesktopTitle className="mb-20">문의 내역</DesktopTitle>
      <div className="flex items-center justify-between px-20 py-8">
        <p className="font-500 text-Gray-black typo-body4">
          총 {data.totalCount.toLocaleString()}개
        </p>
      </div>
      <ul className="flex flex-col">
        {data.list.map(
          ({
            homeInquiryId: home_inquiry_id,
            answer,
            inquiryTypeValue: inquiry_type_value,
            contents,
            createAt: create_at,
            productName: product_name,
            institutionName: institution_name,
            institutionLogoUrl: institution_logo_url,
            writerYN: writer_yn,
            optionItems: option_items,
            privateYN: private_yn,
            title,
            fileUrlList: file_url_list,
            mainImageUrl: main_image_url,
            inquiryTypeCd: inquiry_type_cd,
          }) => (
            <li key={home_inquiry_id}>
              <InquiryCard
                inquiryType={inquiry_type_value}
                contents={contents}
                createAt={create_at}
                productName={product_name}
                institutionName={institution_name}
                institutionLogoUrl={institution_logo_url}
                answer={answer}
                writerYN={writer_yn}
                optionItems={option_items}
                privateYN={private_yn}
                title={title}
                fileUrlList={file_url_list}
                mainImageUrl={main_image_url}
                inquiryId={home_inquiry_id}
                inquiryTypeCd={inquiry_type_cd as InquiryType}
                className="border-b border-Gray-200"
              />
            </li>
          ),
        )}
      </ul>
      {isEmpty && (
        <section className="flex-1 text-center font-400 text-Gray-550 flex-center typo-body3">
          문의 내역이 존재하지 않습니다.
        </section>
      )}
    </section>
  );
};

export default InquiryHistoryPage;
